module.exports = __webpack_public_path__ + "static/media/grayStar.53ba69bd.svg";